import { ForwardedRef, forwardRef } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useResponsive } from 'contexts/useResponsive';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import LogoAvatar from 'images/logo-avatar.svg?react';
import LogoWordmark from 'images/logo-wordmark.svg?react';
import { twMerge } from 'tailwind-merge';

interface HeaderLogoProps extends Omit<LinkProps, 'to'> {}

const HeaderLogo = forwardRef(
    (
        { className, ...restProps }: HeaderLogoProps,
        forwardedRef: ForwardedRef<HTMLAnchorElement>,
    ) => {
        const { accountId } = useCurrentAccount();
        const { isMobile } = useResponsive();

        return (
            <Link
                to={`/accounts/${accountId}/home`}
                ref={forwardedRef}
                className={twMerge('flex items-center gap-2 transition-none', className)}
                {...restProps}
            >
                <LogoAvatar className="h-8 w-8" />
                {!isMobile && <LogoWordmark />}
                <span className="sr-only">Givebutter</span>
            </Link>
        );
    },
);

HeaderLogo.displayName = 'HeaderLogo';

const HeaderLogoFallback = () => {
    const { isMobile } = useResponsive();
    return (
        <div className={'flex items-center gap-2 transition-none'}>
            <LogoAvatar className="h-8 w-8" />
            {!isMobile && <LogoWordmark />}
        </div>
    );
};

export { HeaderLogo, HeaderLogoFallback };
